export const SET_HIRARKI='SET_HIRARKI'
export const GET_PERIODE='GET_PERIODE'
export const GET_TYPE='GET_TYPE'
export const RESET_HIRARKI='RESET_HIRARKI'
